import { Box, Img } from '@chakra-ui/react';
import { WSysLayout, WSysPreferences, useWSysPath } from "@coimbra-its/websys-ux-core";
import "@fontsource/montserrat";
import { Dashboard } from './features/Dashboard';
import { Wallet } from './features/Wallet';
import { useSunStore } from './store/sunSlice';
import { useWeb3 } from './web3/web3';
import { SunBlock } from './components/Sun';
import { PayoutSDBN2Plus } from './features/PayoutSDBN2Plus';
import { WithdrawSDBN2Plus } from './features/WithdrawSDBN2Plus';
import { PayoutSDBN2 } from './features/PayoutSDBN2';
import { WithdrawSDBN2 } from './features/WithdrawSDBN2';




export function App() {

	const path = useWSysPath();
	const web3 = useWeb3();

	const connectedWallet = useSunStore((state) => state.connectedWallet)
	const isLoading = useSunStore((state) => state.isLoading)

	const walletBox = <SunBlock py={3} {...!!connectedWallet && {header:'Connected wallet'}}>
			<w3m-button />
		</SunBlock>


	return <>
		<Box position='fixed' left='50px' top='44px' color='#fff'>
			<Img src='images/sunmoney_logo.png' w='121px' /><br />
		</Box>
		<WSysLayout >
			{path.on('wallet', <Wallet />)}
			{path.on('withdraw_sdbn2', <WithdrawSDBN2 />)}
			{path.on('withdraw_sdbn2plus', <WithdrawSDBN2Plus />)}
			{path.on('admin_payout_sdbn2', <PayoutSDBN2 />)}
			{path.on('admin_payout_sdbn2plus', <PayoutSDBN2Plus />)}
			{path.on('preferences', <WSysPreferences />, { group: 99 })}
			{path.elseOpen(<Dashboard walletBox={walletBox} />)}

		</WSysLayout>

	</>
}